
const animatePlane = function () {
    gsap.to('#blog--plane', {
        x: 0,
        duration: 5,
        ease: "circ.out",
        delay: 3
    });
}

document.addEventListener("DOMContentLoaded", () => {
    animatePlane();

    const joinButton = document.querySelector('.menu-item.btn.join');
    if (joinButton !== null) {
        joinButton.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            window.location.href = "/";
        });
    }
});

